import React from 'react';
import { Link } from 'react-router-dom';

import { doLogout } from '../../../utils/auth';
import { NakedLink } from '../../../utils/NakedLink';

import buildLinks from './buildLinks';
import MobileChatLink from './MobileChatLink';


const InternalHeaderLinks = ({
  isLoggedIn,
  isMobile,
  isAnchor,
  isAnchorPortal,
  user,
}) => {
  const chatAvailable = user.user ? user.user.account.anchorSubscriptions.length > 0 : null;
  const links = buildLinks(user, isAnchorPortal, isLoggedIn, isAnchor, chatAvailable);
  const logout = React.useCallback((event) => {
    event.preventDefault();
    doLogout();
  }, []);

  return (
    <>
      {links.map((link) => (
        <li key={link.id}>
          <NakedLink
            className={window.location.pathname === link.href ? 'active' : null}
            target={link.target ? link.target : ''}
            to={link.href}
          >
            {link.icon && (
              <img
                alt={`${link.title} icon`}
                className={link.absoluteIcon ? 'nav-icon-absolute' : 'anchor-portal-nav-icon'}
                src={link.icon}
              />
            )}
            {link.title}
          </NakedLink>
        </li>
      ))}
      {isMobile && isLoggedIn && !isAnchorPortal && (
        <>
          {chatAvailable && <MobileChatLink />}
          <li>
            <Link to="/account">Account Settings</Link>
          </li>
          <li>
            <a href="#" onClick={logout}>Logout</a>
          </li>
        </>
      )}
    </>
  );
};

export default InternalHeaderLinks;
